import React from 'react';
import ShortcutPage from '../components/ShortcutPage';

interface ContainerProps {
  isFullScreen: boolean;
}

const VideosTab: React.FC<ContainerProps> = ({isFullScreen}) => {
  return (
    <ShortcutPage KEY="VIDEOS" isFullScreen={isFullScreen} />
  )

};

export default VideosTab;
